// @flow
import React from 'react';
import Group from 'sail/Group';
import {ClientSetting} from './components/ClientSetting';

export const REACT_ONLY_SETTINGS = {
  platforms: ['web'],
  clients: {web: ['react']},
  servers: [],
};

export const ReactOnlySettings = () => {
  return (
    <Group direction="horizontal" alignItems="center" spacing={24}>
      <ClientSetting clients={REACT_ONLY_SETTINGS.clients} />
    </Group>
  );
};
